import React, { useState, useEffect, useRef } from "react";
import { clsx } from "clsx";
import {MegamenuFeaturedImages} from "../../MegamenuFeaturedImages/MegamenuFeaturedImages";
import {MegamenuLinks} from "../../MegamenuLinks/MegamenuLinks";
import useMegamenu from "../../hooks/useMegamenu";
import {MegamenuOverlay} from "../../MegamenuOverlay/MegamenuOverlay";

export const Drilldown = ({
    settings,
    menuItems,
    id,
    state
}) => {
    const megamenuRef: any = React.useRef(null);
    const megamenuSM = useMegamenu(megamenuRef, menuItems, true);
    const {
        menuState,
        onLinkHover,
        updateMenuState,
        handleBackClick,
        firstLevelLinks,
        secondLevelLinks
    } = megamenuSM;

    useEffect(() => {

        const handleMobileMenuClosed = () => megamenuSM.handleMenuClose();
        window.addEventListener("mobile-menu-closed", handleMobileMenuClosed);

        if (state === id) {
            onLinkHover(null);
            const newTitle = id.replace("header-", "");

            updateMenuState({
                navigationTitle: newTitle,
                firstMenuTitle: newTitle,
                firstLevelActive: true,
                menuAnimClass: "slide-in-from-right",
                primaryLinksAnim: "slide-in-from-right",
                transitionClass: "",
            });
        }

        return () => {
            window.removeEventListener("mobile-menu-closed", handleMobileMenuClosed);
        };
    }, [state, id]);

    return (
        <>
            <MegamenuOverlay settings={settings} type={'darken'}/>
            <nav
                className={`megamenu-nav`}
                // onAnimationEnd={onAnimationEnd}
                ref={megamenuRef}
            >
                <div className={clsx('relative', { 'container': true })}>
                    <div className="megamenu-nav-area">
                        <div
                            className={`megamenu-nav-list flex-col mobile-menu-drawer h-screen relative block ${clsx({
                                [menuState.menuAnimClass]: (menuState.firstLevelActive || menuState.isSecondLevelVisible),
                            })}`}
                        >
                                (menuState.firstLevelActive ||
                                    menuState.isSecondLevelVisible) && (
                                    <div className="mobile-menu-item b2" onClick={handleBackClick}>
                                        <i className="icon-chevron-left"></i>
                                        {menuState.navigationTitle}
                                    </div>
                                )
                            <div
                                className={`megamenu__primary--links ${clsx({
                                    [menuState.primaryLinksAnim]:
                                    menuState.firstLevelActive &&
                                    !menuState.secondLevelActive,
                                    "slide-out-left":
                                        !menuState.firstLevelActive &&
                                        menuState.secondLevelActive,
                                })}`}
                            >
                                <MegamenuLinks settings={settings} megamenuSM={megamenuSM} />
                            </div>


                            <div
                                className={`megamenu__secondary--links ${clsx({
                                    "slide-in-from-right":
                                        menuState.secondLevelActive &&
                                        !menuState.firstLevelActive,
                                    "slide-out-to-right":
                                        !menuState.secondLevelActive &&
                                        menuState.isSecondLevelVisible,
                                    "force-hidden":
                                        !menuState.secondLevelActive &&
                                        !menuState.isSecondLevelVisible,
                                })}`}
                            >

                                <MegamenuLinks settings={settings} megamenuSM={megamenuSM} level={1} />
                                <MegamenuFeaturedImages settings={settings} megamenuSM={megamenuSM} />
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Drilldown;
